import React from "react";
import './PlanSelection.css'

import { ProductContext } from 'views/pages/LandingPage/Context/productContext.js';
import { useNavigate } from 'react-router-dom';

// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input
} from "reactstrap";
import { openGetAppData } from "../../network/ApiAxios";
import secureLocalStorage from "react-secure-storage";

class PlanSelector extends React.Component {
    static contextType = ProductContext;
    static periodLabels = { 1: "Monthly", 2: "Bimonthly", 3: "Quarterly", 4: "Four-monthly", 5: "Five-monthly", 6: "Semiannual", 7: "Seven-monthly", 8: "Eight-monthly", 9: "Nine-monthly", 10: "Ten-monthly", 11: "Eleven-monthly", 12: "Annual" }

    constructor(props) {
        super(props);

        //Recuperamos as configurações anteiores da página caso
        //o usuário esteja retornando da páginda de login
        const storedPlanData = JSON.parse(localStorage.getItem("selectedPlan"));
        const storedPlanSelectionData = JSON.parse(localStorage.getItem("planSelectionData"));

        this.state = {
            licensesCount: storedPlanData?storedPlanData.licensesCount:1, //quantidade de licenças para configuração custom
            isCustomPlanSelected: storedPlanData?storedPlanData.customPlan:false, //indica se o usuário quer uam configuração custom
            displayPrice: storedPlanData?storedPlanData.price: 0.00, //preço a ser mostrado para o usuario
            appData: {}, //dado do backend para este App
            plansData: [], //lista de planos do App formatada
            periodicity: storedPlanData? storedPlanData.periodicity: 0, //por default vamos considerar periodo zerado
            periodicityOptions: [], //opções de planos para o app para mostrar
            selectedCard: storedPlanSelectionData?storedPlanSelectionData.selectedCard: 0,  //indice do card de opção de plano selecionado
        };
        this.handleCardClick = this.handleCardClick.bind(this);
        this.handleCustomCardClick = this.handleCustomCardClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDeviceCountChange = this.handleDeviceCountChange.bind(this);
        this.incrementDeviceCount = this.incrementDeviceCount.bind(this);
        this.decrementDeviceCount = this.decrementDeviceCount.bind(this);
        this.handleBillingPeriodChange = this.handleBillingPeriodChange.bind(this);
        this.handleAmountDiplay = this.handleAmountDiplay.bind(this);
    }

    componentDidMount() {

        //Bucando dados dos planos para esse aplicativo no
        //backend do Sistema Central
        const runAsync = async () => {
            let alias = this.props.product.id

            const response = await openGetAppData(alias);
            const { data } = response;

            if (data.success) {
                this.setState({ appData: data.app })
                //vamos descobrir as opções de plano do app
                let periodOptions = []
                data.app?.plans?.map(plan => {
                    if (!periodOptions.includes(plan.periodicity)) {
                        periodOptions.push(plan.periodicity)
                    }
                })
                //ordenando periodos de forma crescente
                periodOptions = periodOptions.toSorted()
                this.setState({ periodicityOptions: periodOptions.toSorted() })
                //vamos estabelecer a periodicidade mais frequente como inicial para 
                //mostrar ao usuario, caso não seja um retorno à página
                if(!this.state.periodicity){
                    let period = periodOptions[periodOptions.length - 1]
                    this.setState({ periodicity: period })
                    //vamos filtrar as opções de acordo com a periodicidade e ordenar por limite de licensas
                    let initialPlans = data.app?.plans?.filter(plan => (plan.periodicity == period)).sort((a, b) => (a.licensesLimit - b.licensesLimit))
                    this.setState({ plansData: initialPlans })
                    //definindo o preço padrão inicial, caso não seja um retorno à página
                    this.setState({ displayPrice: initialPlans[0]?.price })
                }else{
                    //vamos filtrar as opções de acordo com a periodicidade e ordenar por limite de licensas
                    let initialPlans = data.app?.plans?.filter(plan => (plan.periodicity == this.state.periodicity)).sort((a, b) => (a.licensesLimit - b.licensesLimit))
                    this.setState({ plansData: initialPlans })
                }
                setTimeout(() => this.updateToggleIndicator(), 100);

            }
        }
        runAsync();

    }

    /**
     * Marca o card padrão escolhido pelo usuário
     * 
     * @param {*} cardIndex 
     * @param {*} price 
     */
    handleCardClick(cardIndex, price, licensesCount) {
        this.setState({
            selectedCard: cardIndex,
            isCustomPlanSelected: false,
            displayPrice: price,
            licensesCount: licensesCount,
        });

    }

    /**
     * Marca no contexto da página que o usuário quer
     * configurar o plano de forma customzada
     * 
     */
    handleCustomCardClick() {
        this.setState({ isCustomPlanSelected: true, selectedCard: -1 })
        this.getCustomPlanPrice(this.state.licensesCount)
    }

    /**
     * Calcula o preço final do plano de acordo com a 
     * configuração customizada da tela
     * 
     * @param {*} licensesCount 
     */
    getCustomPlanPrice(licensesCount, plans) {
        let price = 0

        //Encontrar o primeiro plano com valor que se encaixa 
        //na quantidade de licenças custom e calcular o proporcional
        let updatedPlans = plans ? plans : this.state.plansData
        updatedPlans.map((plan) => {
            if (plan.licensesLimit <= licensesCount) {
                price = plan.price / plan.licensesLimit * licensesCount
            }
        })

        //atualizar os states para mostrar em tela
        this.setState({
            displayPrice: price,
            licensesCount: licensesCount,
            isCustomPlanSelected: true,
            selectedCard: -1,
        })
    }

    /**
     * Trata configurações de quantidade de licensas direto no input
     * 
     * @param {*} event 
     */
    handleDeviceCountChange(event) {
        const value = parseInt(event.target.value);
        const newLicensesCount = isNaN(value) ? 1 : value;
        this.getCustomPlanPrice(newLicensesCount)
        event.stopPropagation();
    }

    /**
     * Trata aumentos de licensas no botão de +
     * Evita que exista cadeia de eventos de 
     * elemtos aninhados (diparados por onclick)
     * 
     * @param {*} event 
     */
    incrementDeviceCount(event) {
        const newLicensesCount = this.state.licensesCount + 1;
        this.getCustomPlanPrice(newLicensesCount)
        event.stopPropagation();
    }

    /**
     * Trata aumentos de licensas no botão de -
     * Evita que exista cadeia de eventos de 
     * elemtos aninhados (diparados por onclick)
     * 
     * @param {*} event 
     */
    decrementDeviceCount(event) {
        const newLicensesCount = this.state.licensesCount > 1 ? this.state.licensesCount - 1 : 1;
        this.getCustomPlanPrice(newLicensesCount)
        event.stopPropagation();
    }

    /**
     * Configura o período dos planos que devem ser mostrados
     * para o usuário na tela
     * 
     * @param {*} newPeriod //um número estabelecido no cadastro do plano
     */
    handleBillingPeriodChange(newPeriod) {
        //vamos atualizar a periodicidade a ser mostrada conforme pedido pelo usuario
        this.setState({ periodicity: newPeriod });
        //vamos filtrar as opções de acordo com a periodicidade e ordenar por limite de licensas
        let plans = this.state.appData?.plans?.filter(plan => (plan.periodicity == newPeriod)).sort((a, b) => (a.licensesLimit - b.licensesLimit))
        let price = plans[this.state.selectedCard]?.price
        this.setState({ plansData: plans, displayPrice: price })
        //caso seja uma configuração custom, atualizar valores em tela de acordo
        if (this.state.isCustomPlanSelected) {
            let licensesCount = this.state.licensesCount
            this.getCustomPlanPrice(licensesCount, plans)
        }

        this.updateToggleIndicator();

    }

    /**
     * Calcula e mostra a quantidade atual de licensas do plano
     * escolhido pelo usuário
     * 
     * @returns 
     */
    handleAmountDiplay() {
        let amount = this.state.isCustomPlanSelected ? this.state.licensesCount : this.state.plansData[this.state.selectedCard]?.licensesLimit
        return (
            <>
                <b className="text-muted ml-2">{amount}</b>
                <small className="text-muted ml-2">license{amount > 1 ? 's' : ''}</small>
            </>
        )
    }

    /**
     * Montamos a carga de dados para poder enviar para a parte
     * de pagamentos que integrará com o PayPal. Ainda não há
     * calculo de desconto nesta etapa.
     * 
     * @param {*} event 
     */
    handleSubmit(event) {
        event.preventDefault();

        //construídos os dados de configuração de plano
        let planData = {
            name: this.state.isCustomPlanSelected ? "Custom plan" : this.state.plansData[this.state.selectedCard]?.name,
            description: `Number of licenses: ${this.state.licensesCount}`,
            price: parseFloat(this.state.displayPrice.toFixed(2)),  //precisa garantir que seja Float
            licensesCount: this.state.licensesCount,
            customPlan: this.state.isCustomPlanSelected,
            pricePerDevice: (this.state.displayPrice / this.state.licensesCount).toFixed(2),
            billingPeriod: PlanSelector.periodLabels[this.state.periodicity],
            periodicity: this.state.periodicity,
        };

        let productData = {
            id: this.state.appData._id,
            name: this.state.appData.name,
            details: this.state.appData.detail,
            productImg: this.props.product.productImg,
        }
        //atualizamos o contexto da compra
        this.context.setSelectedPlan(planData);
        this.context.setSelectedProduct(productData);
        localStorage.setItem('planSelectionData', JSON.stringify({selectedCard: this.state.selectedCard}))

        //Precisamos checar se o usuário está logado antes 
        //de permitir que ele faça uma compra
        const user = JSON.parse(secureLocalStorage.getItem("user"));
        if (!user) {
            this.props.navigate('/auth/login', {state: {origin: `/${this.props.product.id}`}});
        } else {
            this.props.navigate('/checkout');
        }
    }
    updateToggleIndicator() {
        // Aguarda um pouco para garantir que o DOM foi atualizado
        setTimeout(() => {
            const container = document.querySelector('.billing-toggle-container');
            const indicator = container?.querySelector('.toggle-indicator');
            const buttons = container?.querySelectorAll('.billing-toggle-btn');
            
            if (!container || !indicator || !buttons) return;
            
            const totalOptions = this.state.periodicityOptions.length;
            const currentIndex = this.state.periodicityOptions.indexOf(this.state.periodicity);
            
            if (currentIndex === -1) return;
            
            // Pega o botão ativo atual
            const activeButton = buttons[currentIndex];
            if (!activeButton) return;
            
            // Calcula a largura e posição baseada no botão real
            const buttonWidth = activeButton.offsetWidth;
            const buttonLeft = activeButton.offsetLeft;
            
            // Aplica os valores reais ao indicador
            indicator.style.width = `${buttonWidth - 4}px`; // -4px para o padding
            indicator.style.left = `${buttonLeft + 2}px`; // +2px para centralizar
            indicator.style.transform = 'none'; // Remove qualquer transform anterior
        }, 10);
    }

    render() {
        const { product } = this.props;

        return (
            <>
                <section className="section section-lg product-section">
                    <Container>
                        <Row className="photo-col justify-content-center">
                            <Col className="order-md-1 col-img" md="5">
                                <Card>
                                    <img
                                        alt="..."
                                        className="img"
                                        src={product.productImg}
                                    />
                                </Card>
                            </Col>

                            <Col className="plans-col order-md-2" md="7">
                                <h2 className="text-left mb-1">{this.state.appData.name}</h2>
                                <h3 className="text-left mb-3">
                                    {this.state.displayPrice?.toFixed(2)}
                                    <small className="text-muted ml-1">
                                        {'/' + PlanSelector.periodLabels[this.state.periodicity]}
                                    </small>
                                    <small className="text-muted ml-2">for</small>
                                    {this.handleAmountDiplay()}

                                </h3>



                                <div className="text-center mb-4">
                                    <h5 className="mb-2">Choose a plan</h5>

                                    {this.state.periodicityOptions.length > 1 ? (
                                        <div className="billing-toggle-container">
                                            <div className="toggle-indicator"></div>
                                            {this.state.periodicityOptions.map(option => {
                                                return (
                                                    <Button
                                                        key={option}
                                                        className={`billing-toggle-btn ${this.state.periodicity == option ? 'active' : ''}`}
                                                        onClick={() => this.handleBillingPeriodChange(option)}
                                                    >
                                                        {PlanSelector.periodLabels[option]}
                                                    </Button>
                                                )
                                            })}
                                        </div>
                                    ) : (
                                        <div className="single-period-display">
                                            <span className="period-badge">
                                                {PlanSelector.periodLabels[this.state.periodicityOptions[0]]}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                <div className="text-center mb-2">
                                    <strong>Plan</strong>
                                </div>
                                <form onSubmit={this.handleSubmit}>
                                    <Row className="mb-2">
                                        {/** acessando planos, ordenado por quantidade de licensas e montando os cards */}
                                        {this.state.plansData?.map((plan, index) => (
                                            <Col className="px-1 plan-col" md="4" key={plan._id}>
                                                <Card
                                                    className={`text-left align-middle plan-card ${this.state.selectedCard === index ? 'selected-plan' : ''}`}
                                                    onClick={() => this.handleCardClick(index, plan.price, plan.licensesLimit)}
                                                    style={{ height: 'auto' }}
                                                >
                                                    <CardBody className="card-body">
                                                        <h6>{plan.name}</h6>
                                                        <p>{`Up to ${plan.licensesLimit} License${plan.licensesLimit > 1 ? 's' : ''} `}</p>
                                                        <p className="mb-0">
                                                            <strong>
                                                                {`$${plan.price}/${PlanSelector.periodLabels[plan.periodicity]?.toLowerCase()}`}
                                                            </strong>
                                                        </p>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>

                                    <Row>
                                        <Col className="px-1 plan-col" md="12">
                                            <Card
                                                className={`text-left align-middle plan-card custom-plan-card ${this.state.isCustomPlanSelected ? 'selected-plan' : ''}`}
                                                onClick={this.handleCustomCardClick}
                                                style={{ height: 'auto' }}
                                            >
                                                <CardBody className="card-body">
                                                    <h6>Custom plan</h6>
                                                    <p>Number of licenses customized by the user</p>
                                                    <FormGroup className="mb-0">
                                                        <div className="d-flex align-items-center">
                                                            <Button
                                                                color="secondary"
                                                                type="button"
                                                                size="sm"
                                                                onClick={this.decrementDeviceCount}
                                                            >
                                                                -
                                                            </Button>
                                                            <Input
                                                                type="number"
                                                                name="licensesCount"
                                                                id="licensesCount"
                                                                className="mx-2 text-center"
                                                                value={this.state.licensesCount}
                                                                onChange={this.handleDeviceCountChange}
                                                                min="1"
                                                            />
                                                            <Button
                                                                color="secondary"
                                                                type="button"
                                                                size="sm"
                                                                onClick={this.incrementDeviceCount}
                                                            >
                                                                +
                                                            </Button>
                                                        </div>
                                                    </FormGroup>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <Button
                                        color="primary"
                                        type="submit"
                                        size="sm"
                                        block
                                        className="product-button"
                                    >
                                        Add to cart
                                    </Button>
                                </form>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        );
    }
}

function withNavigation(Component) {
    return function WrappedComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    }
}

export default withNavigation(PlanSelector);